import React from "react";
import { Input, Button } from "antd";
import PropTypes from "prop-types";

function ISInformation(props) {
  const { getFieldDecorator, Form } = props;
  return (
    <>
      <Form.Item label="IS User Name">
        {getFieldDecorator("is_user_name")(<Input />)}
      </Form.Item>

      <Form.Item label="IS User Password">
        {getFieldDecorator("is_user_password")(<Input />)}
      </Form.Item>

      {/* <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Previous
        </Button>
        <Button type="primary" onClick={next}>
          Next
        </Button>
      </Form.Item> */}
    </>
  );
}

ISInformation.propTypes = {
  getFieldDecorator: PropTypes.func.isRequired,
  next: PropTypes.func,
  prev: PropTypes.func,
};

ISInformation.defaultProps = {
  next: () => {},
  prev: () => {},
};

export default ISInformation;
